import { Col, Modal, Row } from "antd";
import { Dispatch, SetStateAction, useEffect } from "react";
import { BarcodeOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

type PropsType = {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  item: any;
};
const ItemDetailsModal = ({ isOpen, setIsOpen, item }: PropsType) => {
  const mainCurrencyString = localStorage.getItem("mainCurrency");
  const mainCurrency = mainCurrencyString
    ? JSON.parse(mainCurrencyString)
    : null;

  const [t] = useTranslation("common");

  return (
    <>
      <Modal
        centered
        open={isOpen}
        onOk={() => setIsOpen(false)}
        okButtonProps={{ style: { display: "none" } }}
        onCancel={() => setIsOpen(false)}
        width={800}
        closable={false}
        maskClosable={false}
        cancelButtonProps={{
          style: {
            color: "#1677FF",
            border: "1px solid #1677FF",
            height: "40px",
            width: "100px",
          },
        }}
        cancelText={t("cancel")}
      >
        <Row
          style={{
            border: "1px #1677ff solid",
            padding: "10px",
            borderRadius: "10px",
          }}
        >
          <Col
            span={8}
            style={{
              border: "1px #757575 solid",
              borderRadius: "10px",
              height: "300px",
              overflow: "hidden",
            }}
          >
            <img
              src={
                item?.image
                  ? require(`../../Images/${item?.image}`)
                  : require(`../../../../images/upload photo.png`)
              }
              alt={"item pic"}
              style={{ objectFit: "cover", width: "100%", height: "300px" }}
            />
          </Col>
          <Col
            span={16}
            style={{
              height: "300px",
              padding: "0 10px",
            }}
          >
            <Row
              style={{
                paddingBottom: "20px",
              }}
            >
              <Col
                span={20}
                style={{
                  display: "flex",
                  height: "80px",
                }}
              >
                <h1>{item?.name}</h1>
              </Col>
            </Row>
            <Row
              style={{
                paddingTop: "20px",
                height: "200px",
                borderTop: "1px #BDBDBD solid",
                borderBottom: "1px #BDBDBD solid",
                overflowY: "scroll",
              }}
            >
              {item?.notes || (
                <Col
                  offset={11}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  No Description
                </Col>
              )}
            </Row>
          </Col>
          <Col span={1} style={{ display: "flex", alignItems: "center" }}>
            <BarcodeOutlined style={{ fontSize: "24px", color: "#8C8C8C" }} />
          </Col>
          <Col span={7} style={{ display: "flex", alignItems: "center" }}>
            <h3 style={{ letterSpacing: "2px", color: "#8C8C8C" }}>
              {item?.barcode}
            </h3>
          </Col>
          <Col
            span={10}
            style={{
              display: "flex",
              alignItems: "center",
              paddingLeft: "20px",
            }}
          >
            <h3>{t('in-stock')}: {item?.qtyInStock}</h3>
          </Col>
          <Col
            span={6}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              paddingRight: "20px",
            }}
          >
            <h3>
              {item.price}
              {mainCurrency?.symbol}
            </h3>
          </Col>
        </Row>
      </Modal>
    </>
  );
};

export default ItemDetailsModal;
